module.exports = __webpack_public_path__ + "static/vanezy-a4d9f71766c21f6b09c1618429e4620f.gif";